import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { QuotesRoutingModule } from '@sbd-doug-frontend/app/modules/quotes/quotes-routing.module';
import { SharedPipesModule } from '@sbd-doug-frontend/shared/lib/shared-pipes/shared-pipes.module';
import { environment } from '@sbd-doug-frontend/app/environments/environment';
import { debounceTime, filter, map, Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-quote-request-search-input',
  standalone: true,
  imports: [
    MatAutocompleteTrigger,
    MatFormField,
    MatInput,
    MatLabel,
    QuotesRoutingModule,
    ReactiveFormsModule,
    SharedPipesModule,
  ],
  templateUrl: './quote-request-search-input.component.html'
})
export class QuoteRequestSearchInputComponent implements OnInit {
  @Input() placeholder = 'Search';
  @Input() showClearButton = false;
  @Input() showSearchButton = false;
  @Input() label = 'Search';
  @Input() accountId!: number;

  @Output() recordClickEvent = new EventEmitter<any>();

  _httpClient = inject(HttpClient);
  _unsubscribeAll: Subject<any> = new Subject<any>();
  debounce = 300;
  minLength = 3;
  searchControl: UntypedFormControl = new UntypedFormControl();
  opened = false;
  resultSets: any[];
  private _matAutocomplete: MatAutocomplete;
  searchValue = '';

  _changeDetectorRef = inject(ChangeDetectorRef);


  ngOnInit(): void {
    // Subscribe to the search field value changes
    this.searchControl.valueChanges
      .pipe(
        debounceTime(this.debounce),
        takeUntil(this._unsubscribeAll),
        map((value) => {

          // Set the resultSets to null if there is no value or
          // the length of the value is smaller than the minLength
          // so the autocomplete panel can be closed
          if (!value || value.length < this.minLength) {
            this.resultSets = null;
            this._changeDetectorRef.detectChanges();
          }

          // Continue
          return value;
        }),
        // Filter out undefined/null/false statements and also
        // filter out the values that are smaller than minLength
        filter(value => value && value.length >= this.minLength),
      )
      .subscribe((value) => {
        const queryParams: any = { q: value };
        if (this.accountId > 0) {
          queryParams.account_id = this.accountId;
        }

        this._httpClient.get(environment.apiBaseUrl + '/api/v4/search/basic', {
          params: queryParams,
        })
          .subscribe((resultSets: any) => {
            const requests = resultSets.data.search.search_results.filter(result => result.result_type === 'request');
            const searchResults = [
              {
                label: 'Quote Requests',
                results: requests,
                id: 'quote_requests',
              },
            ];

            // Store the result sets
            this.resultSets = searchResults;

            this._changeDetectorRef.detectChanges();

            // Execute the event
            //this.search.next(searchResults);
          });
      });
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }


  /**
   * On keydown of the search input
   *
   * @param event
   */
  onKeydown(event: KeyboardEvent): void {
    // Escape
    if (event.code === 'Escape') {
      this.closeSearch();
    }
  }


  /**
   * Close the search
   */
  closeSearch(): void {
    // Return if it's already closed
    if (!this.opened) {
      return;
    }

    // Clear the search input
    this.searchControl.setValue('');

    // Close the search
    this.opened = false;
  }


  onEnter(event: any, result: any) {
    if (result && Object.hasOwn(result, 'result_uri')) {
      window.location.href = this.formatUri(result);
    }
  }

  formatUri(result: any) {
    return environment.dougV2BaseUrl + result.result_uri;
  }


  onRecordClickEvent(record: any) {
    this.recordClickEvent.emit(record);
  }

}
